/* -------------------------------------
 Logger Service
 - Log methods to which can be used depending on app environment.
-------------------------------------- */

// Angular services
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

// Our services & pages
import { AppInstance } from '../shared/enums/app-instance.enum';
import { AppConfig }  from '../shared/app-config.service';


@Injectable()
export class LoggerService {

    appInstance: number;

     constructor(public http: Http, appConfig: AppConfig) {
        this.appInstance = appConfig.appInstance;
    }


    public debug(message: any) {
        if (this.appInstance < AppInstance.Test) {
            this.outputToConsole(message);
        }
    }

    // Output in production 
    public info(message: any) {
       if (this.appInstance < AppInstance.Test) {
           this.outputToConsole(message);
       }
    }

    // Output in production
    public warning(message: any) {
       if (this.appInstance < AppInstance.Test) {
           this.outputToConsole(message);
       }
    }

    // All error or catch block should ensure this logger method is called
    public error(message: any) {
        if (this.appInstance < AppInstance.Test) {
            this.outputToConsole(message);
        }
    }


    private outputToConsole(message: any) {
        console.log(message);
    }

}


// WEBPACK FOOTER //
// ./src/shared/logger.service.ts